import React, { useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import "../Blog.css";
import arrow from "../../../assets/kangaroo/arrow-cropped.svg";
import { Col, Container, Row, Spinner } from "reactstrap";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import { blogData } from "../data";
import MediumButton from "../../../component/button/MediumButton";
import { Link, useNavigate } from "react-router-dom";
import SmallPage from "../../../Homepage/SmallPage";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Map from "../../../Homepage/Map";
import Smallbutton from "../../../component/button/Smallbutton";
import BlogService from "../../../services/BlogService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";
import { formatDate } from "../../../common/formatedate";
import { RotatingTriangles } from 'react-loader-spinner'
import { div } from "framer-motion/client";

const ITEMS_PER_PAGE = 6;

const BlogLanding = () => {
  const router = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);

  // -------- Fetch All Blogs --------
  const fetchBlogs = async ({ queryKey }) => {
    const [_key, currentPage] = queryKey;

    return BlogService.getList({
      page: currentPage,
      pageSize: ITEMS_PER_PAGE,
      status: 2
    });
  };


  const {
    isLoading,
    error,
    data: blogResponse,
  } = useQuery({
    queryKey: ["blogList", currentPage], // 👈 page-aware cache
    queryFn: fetchBlogs,
    keepPreviousData: true, // 👈 smooth pagination
  });

  const blogItems = blogResponse?.items || [];
  const totalPages = blogResponse?.totalPages || 1;

  // -------- Fetch Featured Blogs --------
  const fetchFeaturedBlogs = async () => {
    const response = await BlogService.getfeaturedblogs();
    return response?.items;
  };

  const {
    data: featuredBlogDatas,
    isLoading: featuredPending,
  } = useQuery({
    queryKey: ["featuredBlogList"],
    queryFn: fetchFeaturedBlogs,
  });

  if (isLoading) return <div className="h-100 w-100 d-flex justify-content-center align-items-center"> <RotatingTriangles
visible={true}
height="80"
width="80"
color="#4fa94d"
ariaLabel="rotating-triangles-loading"
wrapperStyle={{}}
wrapperClass=""
/>
</div>
  if (error) return <p>Error: {error.message}</p>;


  // -------- Pagination Logic --------

  const paginatedBlogs = blogItems.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );
  const changePage = (newPage) => {
    setCurrentPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const getPageButtonStyle = (isActive) => ({
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    border: "none",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.3s ease",
    background: isActive ? "#7e1790" : "transparent",
    color: isActive ? "white" : "#374151",
    transform: isActive ? "scale(1.1)" : "scale(1)",
  });
  return (
    <>
      <SectionContainer>
        <style>
          {`
          .shine-button {
            position: absolute;
            overflow: hidden; /* Keeps the shine inside the border radius */
          }

          /* The shine element */
          .shine-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%; /* Start off-screen to the left */
            width: 100%;
            height: 100%;
            background: linear-gradient(
              120deg, 
              transparent, 
              rgba(255, 255, 255, 0.4), 
              transparent
            );
            transition: all 0.6s ease-in-out;
          }

          /* Trigger animation on hover */
          .shine-button:hover::before {
            left: 100%; /* Slide off-screen to the right */
          }
        `}
        </style>
        <Container fluid className="p-0">
          <BreadCrumb
            items={[{ title: "HOME", link: "/" }, { title: "BLOG" }]}
            instituition={false}
          />

          <Row>
            <Col lg={5} sm={12}>
              <h1 className="font-level-4 mt-2">BLOG</h1>
            </Col>
            {/* <Col lg={7} sm={12} style={{ paddingRight: "" }}>
              {" "}
              <div className="d-none d-lg-block d-md-block position-relative w-100">
                <input
                  type="text"
                  className="w-100 px-4 rounded"
                  placeholder="SEARCH A BLOG"
                  style={{
                    paddingTop: "0.75rem",
                    paddingBottom: "0.75rem",
                    paddingRight: "150px",
                    fontSize: "clamp(0.85rem, 2vw, 1rem)",
                    width: "867.9918px",
                    height: "70.8661px",
                    border: "1.5px solid #687C86",
                  }}
                />
                <button
                  className="d-flex align-items-center gap-2 rounded-pill border-0 position-absolute shine-button"
                  style={{
                    right: -30,
                    top: 0,
                    bottom: 0,
                    background: "linear-gradient(to right, #7e1790, #d70a84)",
                    color: "white",
                    padding: "0 1rem",
                    fontSize: "clamp(0.7rem, 1.8vw, 0.9rem)",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    width: "235px",
                    height: "70.8661",
                    overflow: "hidden", // Added to crop the animation
                  }}
                >
                  <img
                    src={arrow}
                    alt=""
                    style={{
                      height: "60%",
                      width: "auto",
                      position: "relative",
                      zIndex: 1,
                    }}
                  />
                  <span
                    className="font-level-9"
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    SEARCH
                  </span>
                </button>
              </div>


<div className="d-block d-md-none position-relative w-100">
  <input
    type="text"
    className="w-100 px-4"
    placeholder="SEARCH A BLOG"
    style={{
      paddingTop: "0.75rem",
      paddingBottom: "0.75rem",
      fontSize: "clamp(0.85rem, 2vw, 1rem)",
      height: "60px",
      borderRadius: "8px",
      border: "1.5px solid #687C86",
    }}
  />
  <div className="d-flex justify-content-center">
    <button
      className="d-flex align-items-center justify-content-center gap-2 rounded-5 border-0 shine-button mt-2"
      style={{
        background: "linear-gradient(to right, #7e1790, #d70a84)",
        color: "white",
        padding: "0.5rem 1rem",
        fontSize: "clamp(0.8rem, 2vw, 1rem)",
        cursor: "pointer",
        width: "60%",
        height: "60px",
      }}
    >
      <img
        src={arrow}
        alt=""
        style={{
          height: "70%",
          width: "auto",
          position: "relative",
          zIndex: 1,
          left:"-8px"
        }}
      />
      <span
        className="font-level-9"
        style={{ position: "relative", zIndex: 1 }}
      >
        SEARCH
      </span>
    </button>
  </div>
</div>

              
            </Col> */}
          </Row>
          {featuredBlogDatas?.length > 0 && (<Row
            className="rounded-4"
            style={{
              overflow: "hidden",
              marginTop: "35px",
              marginBottom: "68px",
            }}
          >
            <Col className="pe-0" lg={6}>
              <div style={{ width: "100%", height: "547px" }} className="">
                <img
                  src={`${imageBaseApi}${featuredBlogDatas?.[0]?.thumbnailMedia?.url}`}
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderTopLeftRadius: "1rem",
                    borderBottomLeftRadius: "1rem",
                  }}
                />
              </div>
            </Col>
            <Col
              className="pe-0 pt-5 pb-5 pt-lg-0 pb-lg-0 d-flex flex-column justify-content-center align-items-center"
              lg={6}
              style={{ background: "#7e17901A" }}
            >
              <div className="w-75">
                <p className="blog-date" style={{ marginBottom: "50px" }}>
                  Published on {formatDate(featuredBlogDatas?.[0]?.publishedAt)}
                </p>
                <h1
                  className="blog-title lh-1"
                  style={{ marginBottom: "5rem" }}
                >
                  {featuredBlogDatas?.[0]?.title}
                </h1>
                <div>
                  <Link
                    to={`/blog/${featuredBlogDatas?.[0]?.slug}`}
                    className="text-decoration-none"
                  >
                    <Smallbutton text="READ MORE" />
                  </Link>
                </div>
              </div>
            </Col>
          </Row>)}
          <Row className="d-flex  " style={{ marginRight: "-6%" }}>
            {blogItems?.map((blog, index) => (
              <React.Fragment key={index}>
                <Col
                  lg={4}
                  md={6}
                  sm={12}
                  className="d-flex flex-column mb-md-0 mb-4"
                  style={{ cursor: "pointer" }}
                // onClick={() => router(`/blog/${blog?.slug}`)}
                >
                  <Link
                    to={`/blog/${blog?.slug}`}
                    className="text-decoration-none"
                  >
                    <div
                      style={{ width: "90%", height: "247px" }}
                      className="rounded-5"
                    >
                      <img
                        loading="lazy"
                        src={`${imageBaseApi}${blog?.thumbnailMedia?.url}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        fluid
                        className="rounded-5 img-fluid"
                        alt={blog?.title}
                      />
                    </div>
                    <p className="blog-desc" style={{ marginTop: "24px" }}>
                      Published On: {formatDate(blog?.publishedAt)}
                    </p>
                    <div style={{ width: "90%" }}>
                      <h5 className="recent-title">{blog?.title}</h5>
                    </div>
                    <p
                      className="country-paragraph-text m-0"
                      style={{ width: "90%" }}
                    >
                      {blog?.content
                        ?.replace(/<[^>]*>/g, "")      // remove HTML tags
                        .replace(/\s+/g, " ")          // remove enter/newline & extra spaces
                        .trim()                        // remove leading/trailing spaces
                        .split(" ")
                        .slice(0, 25)
                        .join(" ")}{" "}
                      [...]

                    </p>
                  </Link>
                </Col>

                {(index + 1) % 3 === 0 && (
                  <Col xs={12}>
                    <hr
                      className={
                        index + 1 === paginatedBlogs.slice(1).length
                          ? "line-style-testprep"
                          : "line"
                      }
                    />
                  </Col>
                )}
              </React.Fragment>
            ))}
          </Row>

          {totalPages > 1 && (
            <div
              className="w-100 d-flex justify-content-end"
              style={{ marginTop: "20px", marginBottom: "13rem" }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {/* Previous */}
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "none",
                    background: "transparent",
                    color: "#6b7280",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    opacity: currentPage === 1 ? 0.4 : 1,
                  }}
                >
                  <ChevronLeft size={18} />
                </button>

                {/* Page numbers with ellipsis logic */}
                {(() => {
                  const maxVisible = 5;
                  let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                  let end = Math.min(totalPages, start + maxVisible - 1);

                  // Adjust start if we're near the end
                  if (end - start + 1 < maxVisible) {
                    start = Math.max(1, end - maxVisible + 1);
                  }

                  const showPages = [];

                  // Always show page 1
                  if (start > 1) {
                    showPages.push(
                      <button
                        key={1}
                        onClick={() => setCurrentPage(1)}
                        style={getPageButtonStyle(1 === currentPage)}
                      >
                        1
                      </button>
                    );
                    if (start > 2) {
                      showPages.push(<span key="left-ellipsis">...</span>);
                    }
                  }

                  // Visible range
                  for (let page = start; page <= end; page++) {
                    showPages.push(
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={getPageButtonStyle(page === currentPage)}
                      >
                        {page}
                      </button>
                    );
                  }

                  // Always show last page
                  if (end < totalPages) {
                    if (end < totalPages - 1) {
                      showPages.push(<span key="right-ellipsis">...</span>);
                    }
                    showPages.push(
                      <button
                        key={totalPages}
                        onClick={() => setCurrentPage(totalPages)}
                        style={getPageButtonStyle(totalPages === currentPage)}
                      >
                        {totalPages}
                      </button>
                    );
                  }

                  return showPages;
                })()}

                {/* Next */}
                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "none",
                    background: "transparent",
                    color: "#6b7280",
                    cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                    opacity: currentPage === totalPages ? 0.4 : 1,
                  }}
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          )}
        </Container>
      </SectionContainer>

      <hr className="line" style={{ marginTop: "2rem" }} />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default BlogLanding;
